$lines: 1 2 3;
$default-font-size: 20px;

:host {
    display: block;
    box-sizing: border-box;
    margin-top: var(--wf-badge-margin-top, 0);
}

.wf-badge {
    display: inline-grid;
    padding: var(--wf-badge-padding-top, 4px) var(--wf-badge-padding-x, 4px) var(--wf-badge-padding-bottom, 4px) var(--wf-badge-padding-x, 4px);
    font-size: var(--wf-badge-font-size, $default-font-size);
    font-weight: var(--wf-badge-font-weight, 600);
    text-transform: uppercase;
    text-align: var(--wf-badge-text-align, left);
    background-color: var(--wf-badge-background-color, #ea5659);
    color: white;

    grid-template-columns: repeat(2, auto);
    grid-template-rows: auto;

    .vx-icon {
        grid-column: 1 / 2;

        filter: invert(100%) sepia(0%) saturate(5824%) hue-rotate(312deg) brightness(115%) contrast(102%);

        width: 24px;
        height: 24px;

        align-self: center;

        & + .wf-label {
            grid-column: 2 / 3;
        }

    }

    .wf-label {
        display: inline-block;
        grid-column: 1 / 3;

        line-height: 1;

        .wf-label-line {
            display: block;
            line-height: 1;

            @each $line in $lines {
                &.wf-label-line-#{$line} {
                    font-size: var(--wf-badge-line-#{$line}-font-size, var(--wf-badge-font-size, $default-font-size));
                    font-weight: var(--wf-badge-line-#{$line}-font-weight, var(--wf-badge-font-weight, 600));
                    line-height: var(--wf-badge-line-#{$line}-line-height, 1);
                    font-family: var(--wf-badge-line-#{$line}-font-family, inherit);
                }
            }
        }
    }
}
